
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/terms-of-service",
      function () {
        return require("private-next-pages/about/terms-of-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/terms-of-service"])
      });
    }
  